import { Image } from "ol/layer";
import ImageArcGISRest from "ol/source/ImageArcGISRest";
import { ServerLayer } from "../../../lib/layers";
import { Some } from "../../../lib/misc/option";
export class LabelLayer extends ServerLayer {
    constructor(opts) {
        super(opts);
    }
    validate(opts) {
        let result = true;
        result && (result = !!opts.name);
        result && (result = typeof opts.exportUrl === 'string');
        return result;
    }
    get layers() {
        return this.raw.map(l => [l]).unwrapOr([]);
    }
    async parse_config(opts) {
        const api = await this.get_service_api([opts.infoUrl]);
        this.projection = api.projection;
        let layer = new Image({
            source: new ImageArcGISRest({
                params: opts.details,
                url: api.endpoints[0],
                crossOrigin: 'anonymous',
                hidpi: false,
                projection: api.projection
            }),
            visible: opts.visible,
            opacity: 0.7
        });
        this.raw = new Some(layer);
        this.is_base = opts.isBaseLayer;
        this.name = opts.name;
    }
}
